var map = {
	"./bug.svg": 4303,
	"./dark.svg": 2804,
	"./dragon.svg": 8178,
	"./electric.svg": 1084,
	"./fairy.svg": 127,
	"./fighting.svg": 7883,
	"./fire.svg": 5152,
	"./flying.svg": 5348,
	"./ghost.svg": 4364,
	"./grass.svg": 9164,
	"./ground.svg": 6530,
	"./ice.svg": 7923,
	"./normal.svg": 507,
	"./poison.svg": 72,
	"./psychic.svg": 110,
	"./rock.svg": 1303,
	"./shadow.svg": 746,
	"./steel.svg": 8665,
	"./unknown.svg": 3423,
	"./water.svg": 6150
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4793;